import { __rest } from "tslib";
import React, { useState } from 'react';
import { GroupContext } from './context';
export const TimeLinePickerGroup = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [uniqueId, setUniqueId] = useState();
    return (React.createElement(GroupContext.Provider, { value: {
            props,
            onIdChange: setUniqueId,
            uniqueId,
        } }, children));
};
